import React, { useRef, useState } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const MESSAGE = 'Available when signed in';

const useLockTooltip = () => {
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const show = () => setOpen(true);
  const hide = () => setOpen(false);
  const explain = (event) => {
    event.preventDefault();
    event.stopPropagation();
    show();
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(hide, 1800);
  };
  return { open, show, hide, explain };
};

export function LockedButton({ children, startIcon, ...props }) {
  const tooltip = useLockTooltip();
  return (
    <Tooltip title={MESSAGE} open={tooltip.open} onClose={tooltip.hide} disableHoverListener>
      <Button
        {...props}
        aria-disabled="true"
        aria-label={`${props['aria-label'] || children}. ${MESSAGE}`}
        onMouseEnter={tooltip.show}
        onMouseLeave={tooltip.hide}
        onFocus={tooltip.show}
        onBlur={tooltip.hide}
        onClick={tooltip.explain}
        startIcon={startIcon}
        endIcon={<LockOutlinedIcon fontSize="small" />}
      >
        {children}
      </Button>
    </Tooltip>
  );
}

export function LockedIconButton({ label, children, ...props }) {
  const tooltip = useLockTooltip();
  return (
    <Tooltip title={MESSAGE} open={tooltip.open} onClose={tooltip.hide} disableHoverListener>
      <IconButton
        {...props}
        aria-disabled="true"
        aria-label={`${label}. ${MESSAGE}`}
        onMouseEnter={tooltip.show}
        onMouseLeave={tooltip.hide}
        onFocus={tooltip.show}
        onBlur={tooltip.hide}
        onClick={tooltip.explain}
        sx={{ ...props.sx, position: 'relative' }}
      >
        {children}
        <Box component="span" sx={{ position: 'absolute', right: -3, bottom: -3, width: 17, height: 17, borderRadius: '50%', bgcolor: 'background.paper', display: 'grid', placeItems: 'center', border: 1, borderColor: 'divider' }}>
          <LockOutlinedIcon sx={{ fontSize: 11 }} />
        </Box>
      </IconButton>
    </Tooltip>
  );
}
